import { useStyletron } from "baseui";
import { Button, KIND, SHAPE, SIZE } from "baseui/button";
import { ListItem } from "baseui/list";
import { VscAdd, VscCalendar, VscLink, VscTrash } from "react-icons/vsc";
import { TScheduler, TSpecialEvent } from "../types";
import { ExceptionsListItem } from "./ExceptionsListItem";
import { SpecialEventDto } from "../../../../services/schedulers/types";
import { IoCalendarNumberOutline } from "react-icons/io5";
import { AddExceptionDialogButton } from "./AddExceptionDialog/AddExceptionDialogButton";
import { ICalendar } from "../../Calendar";
import { BacnetObjectTypes } from "../../../../services/mapping/bacnet";
import { EmptyState } from "../../../../components/EmptyState";
import { FormattedMessage, useIntl } from "react-intl";
import { LabelMedium } from "baseui/typography";
import { ACTION_POSITION, Banner } from "baseui/banner";
import { AddExceptionDialog } from "./AddExceptionDialog/AddExceptionDialog";
import { useState } from "react";

const ExceptionsList = (props: {
  app: TScheduler, items: TSpecialEvent[], selected: any,
  onAddItem(item: TSpecialEvent),
  onItemSelected: (item: any) => void,
  onDeleteItem: (item: TSpecialEvent) => void
}) => {
  const [css, theme] = useStyletron();
  const [isOpen, setIsOpen] = useState(false);

  const intl = useIntl();

  function onSelect(item: any) {
    props.onItemSelected(item)
  }
  const onAdd = (item: { eventPrio: number, calendar: ICalendar }) => {
    props.onAddItem({
      eventPriority: item.eventPrio,
      entries: [],
      calendarReference: {
        instanceId: 0,
        type: BacnetObjectTypes.CALENDAR,
        twinId: item.calendar.id,
        twinResourceGroupId: item.calendar.resourceGroupId
      }
    })
  }

  const filterAlreadyAddedCalendars = (item: ICalendar) => !props.items.some((v: TSpecialEvent) => v.calendarReference?.twinId === item.id);
  const hasItems = props.items && props.items.length > 0;

  return (

    <div className={css({
      position: 'relative',
      ///height: '100%'
    })}>
      <ul
        className={css({
          width: '300px',
          paddingLeft: 0,
          paddingRight: 0,
        })}
      >
        {hasItems ?
          <>{
            props.items.map((item: TSpecialEvent, index: number) => {
              const overrides = item === props.selected ? {
                Root: {
                  style: ({ $theme }) => ({
                    backgroundColor: $theme.colors.accent100
                  })
                }
              } : {}

              return (
                <div onClick={() => onSelect(item)}>
                  <ListItem
                    shape="ROUND"
                    overrides={overrides}
                    artwork={props => item.calendarReference ? <VscCalendar {...props}></VscCalendar> : <IoCalendarNumberOutline {...props} />}
                    endEnhancer={() => (
                      <Button kind="secondary" size="compact" shape="circle" onClick={() => props.onDeleteItem(item)}><VscTrash></VscTrash></Button>
                    )}
                  >
                    <>
                      <ExceptionsListItem app={props.app} item={item}></ExceptionsListItem>
                      {item.entries.length === 0 && <LabelMedium className={css({ color: theme.colors.warning600 })}><FormattedMessage id='Calendar.noEntries' defaultMessage={'Empty'}></FormattedMessage></LabelMedium>}
                    </>
                  </ListItem>
                </div>)
            }
            )
          }</>
          :
          <Banner title={intl.formatMessage({ id: "noItems", defaultMessage: "No items" })} kind={'info'} action={{
            label: intl.formatMessage({ id: "add", defaultMessage: "Add" }),
            onClick: () => { setIsOpen(true) },
            position: ACTION_POSITION.below,
          }}>
            {intl.formatMessage({ id: "Scheduler.NoExceptionSchedules", defaultMessage: "No Exception schedules defined" })}
          </Banner>
        }
      </ul>
     
        <div className={css({
          position: 'absolute',
          bottom: '-20px',
          right: '-20px',
          zIndex: 9999,
        })}>
          <>
           {hasItems &&  <Button onClick={() => setIsOpen(true)} kind={KIND.primary} size={SIZE.default} shape={SHAPE.round} overrides={{
              BaseButton: {
                style: ({ $theme }) => ({
                  boxShadow: $theme.lighting.shadow400,
                })
              }
            }}
            >
              <VscAdd></VscAdd>
            </Button>}
            {isOpen && <AddExceptionDialog calendarsFilter={filterAlreadyAddedCalendars} app={props.app} isOpen={isOpen} setIsOpen={setIsOpen} onAdd={onAdd}></AddExceptionDialog>}
          </>
        </div>
      
    </div>

  )
}



export default ExceptionsList;




